import { sendAnalytics } from '@audio-network/analytics'

import { getLabelCode } from '@/constants/trackLabelCodes'

export const handleCopy = async (
	table: string,
	buttonType: 'copy-all' | 'copy' | 'copy-lyrics'
): Promise<void> => {
	sendAnalytics({
		noun:
			buttonType === 'copy-all'
				? 'Copy All Cue Sheet Information'
				: buttonType === 'copy'
				? 'Copy Cue Sheet Information'
				: 'Copy Lyrics',
		pastTenseVerb: 'Clicked',
	})

	try {
		await navigator.clipboard.writeText(table)
	} catch (err) {
		console.error('Failed to copy: ', err)
	}
}

export const handleArtistClicked = (name: string): void => {
	sendAnalytics({
		noun: 'Artist',
		pastTenseVerb: 'Clicked',
		eventParameters: {
			ArtistName: name,
		},
	})
}

export const buildCueSheet = (track: Track): string => {
	return `Title\tComposer\tPublisher\tISWC\tISRC\tLabel Code\n${
		track.title
	}\t${track.composers
		.map(
			(composer) =>
				`${composer.name} (${composer.collectionSociety}) [${composer.ipi}] ${composer.split}%`
		)
		.join(', ')}\t${track.publishers
		.map(
			(publisher) =>
				`${publisher.name} (${publisher.collectionSociety}) [${publisher.ipi}] ${publisher.split}%`
		)
		.join(', ')}\t${track.iswc ?? ''}\t${track.isrc ?? ''}\t${track.publishers
		.map((publisher) => getLabelCode(publisher.name))
		.join(', ')}`
}

export const buildComposersTable = (composers: Composer[]): string => {
	return composers
		.map((composer) => {
			return `${composer.name} ${composer.collectionSociety}: ${composer.ipi}, ${composer.split}%`
		})
		.join('\n')
}

export const buildPublishersTable = (publishers: Publisher[]): string => {
	return publishers
		.map((publisher) => {
			return `${publisher.name} ${publisher.collectionSociety}: ${publisher.ipi}, ${publisher.split}%`
		})
		.join('\n')
}

export const setLabelCode = (publisher: Publisher): number => {
	return getLabelCode(publisher.name)
}
